/**
 * Normalize the widget's i18n language into a value Stripe Elements accepts.
 *
 * Stripe Elements only supports a fixed set of IETF tags
 * (https://docs.stripe.com/js/appendix/supported_locales). Passing an
 * unknown tag — e.g. `hu-HU` instead of `hu` — 400s the
 * /v1/elements/sessions call and the Payment Element fails to load on
 * second split-payment legs. The widget stores a 2-letter internal code
 * (`en`, `hu`, `jp`); map it to Stripe's expected form.
 *
 * `auto` lets Stripe fall back to its own browser detection, which is
 * safer than asserting a locale we're not sure about.
 */
export function toStripeLocale(
    lang: string | null | undefined,
): 'auto' | 'en' | 'en-GB' | 'hu' | 'ja' {
    const normalized = (lang || '').toLowerCase();
    switch (normalized) {
        case 'en':
        case 'en-us':
            return 'en';
        case 'en-gb':
            return 'en-GB';
        case 'hu':
        case 'hu-hu':
            return 'hu';
        case 'jp':
        case 'ja':
        case 'ja-jp':
            return 'ja';
        default:
            return 'auto';
    }
}
